"use strict";Object.defineProperty(exports,"__esModule",{value:!0});var b=require("./utils/freeze.js"),a=function(a,c){this.inlineSize=a,this.blockSize=c,b.freeze(this)};exports.ResizeObserverSize=a
//# sourceMappingURL=ResizeObserverSize.js.map
